import * as React from 'react';

import SVGDynamicIcon from 'components/svg-dynamic-icon/SVGDynamicIcon';

import './upload-placeholder.scss';

type Props = {
  title: string | undefined | null,
  onClick?: () => void
};

const UploadPlaceholder = (
  {
    title,
    onClick
  }: Props
): JSX.Element => (
  <div className="upload-placeholder__main">
    <div
      onClick={onClick}
      className="upload-placeholder__container"
    >
      <SVGDynamicIcon
        name="plus-inside-circle-white-bg-custom-fg"
        width={25}
        height={25}
        customColor="grey"
      />
      <div className="upload-placeholder__text">
        {title}
      </div>
    </div>
  </div>
);

export default UploadPlaceholder;
